import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataProvider } from '../data/data';
import { CompanyConfig, Company, Method } from '../../models/company-config';
import { LoginProvider } from '../login/login';

const ROUTE = "config";

@Injectable()
export class CompanyConfigProvider extends DataProvider<CompanyConfig> {

  constructor(private loginProvider: LoginProvider) {
    super("CompanyConfig");

  }

  /**
   * Returns CompanyConfig from local storage or web API.
   */
  private async getCompanyConfig(): Promise<CompanyConfig> {
    return this.storage.get().then(x => {
      if (x.available) {
        return x.data;
      } else {
        return this.auth.get(ROUTE).then(r => {
          this.storage.set(r);
          return r as CompanyConfig;
        });
      }
    });
  }

  /**
   * Returns all company information.
   */
  public async getCompany(): Promise<Company> {
    return this.getCompanyConfig().then(x => x.company);
  }

  /**
   * Returns available delivery methods for company.
   */
  public async getDeliveryMethods(): Promise<Array<Method>> {
    return this.getCompanyConfig().then(x => x.delivery_methods);
  }

  /**
   * Returns available payment methods for company.
   */
  public async getPaymentMethods(): Promise<Array<Method>> {
    return this.getCompanyConfig().then(x => x.payment_methods);
  }

  /**
   * Returns html content pages for company.
   */
  public async getHtmlContents(): Promise<Array<any>> {
    return this.getCompanyConfig().then(x => x.html_contents);
  }

  /**
   * Returns html content pages for company.
   */
  public async isRegistrationAllowed(): Promise<boolean> {
    return this.getCompanyConfig().then(x => {
      return x.is_registration_allowed == 1;
    });
  }

  /**
   * Returns if user can see price.
   */
  public async canSubmitOrder(): Promise<boolean> {
    if (this.loginProvider.isAnonymousSession) {
      return this.getCompanyConfig().then(x => {
        return x.can_submit_order == 1;
      });
    }
    return true;
  }

  /**
   * Returns if user can see price.
   */
  public async canSeePrice(): Promise<boolean> {
    if (this.loginProvider.isAnonymousSession) {
      return this.getCompanyConfig().then(x => {
        return x.can_see_price == 1;
      });
    }
    return true;
  }

  /**
   * Returns html content pages for company.
   */
  public async isLoginRequired(): Promise<boolean> {
    return this.getCompanyConfig().then(x => {
      return x.is_login_required == 1;
    });
  }
  public async getTermsAndConditionsUrl(): Promise<string> {
    return this.getCompanyConfig().then(x => {
      return x.terms_and_conditions_url;
    });
  }

  /**
   * Downloads company config and saves it in storage.
   */
  public async syncCompanyConfig() {
    this.auth.get(ROUTE).then(r => {
      this.storage.set(r);
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/company-config/company-config.ts